<template>
  <div>
    <v-container>
      <h1>PME Approvers Setup</h1>
      <v-card>
        <!-- <v-toolbar flat color="primary" dark>
          <v-toolbar-title>PM</v-toolbar-title>
        </v-toolbar>-->
        <v-tabs vertical>
          <v-tab class="text-none">Groups</v-tab>
          <v-tab class="text-none">Approvers</v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <!-- <router-view /> -->
                <group></group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <!-- <router-view /> -->
                <approver></approver>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Group from "./group/Index";
import Approver from "./approver/Index";
export default {
  metaInfo: {
    title: "PME Approvers",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    tab: "1"
  }),
  components: {
    Group,
    Approver
  }
};
</script>